import { useEffect } from 'react';

export function JsonLd({ id, data }: { id: string; data: unknown }) {
  const json = JSON.stringify(data);
  useEffect(() => {
    const el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    el.text = json;
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    document.head.appendChild(el);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, [id, json]);
  return null;
}
